import React from 'react';
import { Link } from 'react-router-dom';
import './PopularBrands.scss';
import { BRANDS } from '../../utils/brands';

// Home "Популярні бренди" (2026-09). Curated from a real production
// inventory audit (511 active fashion listings, title/description text
// matching — attributes.brand is still empty on every real listing today,
// the field only exists since the Phase 2 CreateListing addition) — NOT
// copied from any reference UI's brand list. The brand list itself (slug/
// name/aliases/logo) now lives in src/utils/brands.js, reused wherever a
// brand needs to be rendered, not just here.
export default function PopularBrands() {
  return (
    <div className="popular-brands">
      <div className="popular-brands__header">
        <span className="popular-brands__title">Популярні бренди</span>
        <Link to="/search?shoppingOnly=1" className="popular-brands__all">
          Всі →
        </Link>
      </div>

      <div className="popular-brands__row">
        {BRANDS.map((brand) => (
          <Link
            key={brand.slug}
            to={`/search?brand=${brand.slug}`}
            className="popular-brands__item"
            aria-label={brand.name}
          >
            <span className="popular-brands__circle">
              {brand.logo ? (
                <img src={brand.logo} alt={brand.name} className="popular-brands__logo" loading="lazy" />
              ) : (
                <span className="popular-brands__wordmark">{brand.name}</span>
              )}
            </span>
            <span className="popular-brands__label">{brand.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
